import { User } from "../user/user.model";
import { BaseRate } from "./rate-base.model";
import { Client } from "../client/client.model";
import { Rate } from "./rate-type";
import { Carrier } from "../carrier/carrier.model";
import { RateFtlFlatRoute } from "./rate-flat-route-list/rate-ftl-route.model";
import { RateLocation } from "./rate-location/rate-location.type";

export class FtlFlatRate extends BaseRate {
  constructor(
    protected id: number,
    protected name: string,
    protected discriminator: string,
    protected createdBy?: User,
    protected updatedBy?: User,
    protected createdAt?: Date,
    protected updatedAt?: Date,
    protected type?: string,
    protected source?: string,
    protected status?: string,
    protected internalNote?: string,
    protected externalNote?: string,
    protected pmNote?: string,
    protected comment?: string,
    protected deepLink?: string,
    protected carrier?: Carrier,
    protected validity?: Date[],
    protected currency?: string,
    protected contractNumber?: string,
    protected availableOnline?: boolean,
    protected restrictedClients?: Client[],
    protected restrictedUsers?: User[],
    protected rootParent?: Rate,
    protected flatRateRoutes?: RateFtlFlatRoute[],
    // TODO: We should consider a new model LtlFreightRate for this
    protected originLocation?: RateLocation,
    protected destinationLocation?: RateLocation,
    protected blPrice?: number,
    protected blPriceMargin?: number,
  ) {
    super(
      id,
      name,
      discriminator,
      createdBy,
      updatedBy,
      createdAt,
      updatedAt,
      type,
      source,
      status,
      internalNote,
      externalNote,
      pmNote,
      comment,
      deepLink,
      carrier,
      validity,
      contractNumber,
      restrictedClients,
      restrictedUsers,
      rootParent,
    );
  }

  public getOriginLocation(): RateLocation {
    return this.originLocation;
  }

  public setOriginLocation(param: RateLocation): void {
    this.originLocation = param;
  }

  public getDestinationLocation(): RateLocation {
    return this.destinationLocation;
  }

  public setDestinationLocation(param: RateLocation): void {
    this.destinationLocation = param;
  }

  public getCurrency() {
    return this.currency;
  }

  public setCurrency(currency: string) {
    this.currency = currency;
  }

  public getFlatRateRoutes() {
    return this.flatRateRoutes;
  }

  public getAvailableOnline() {
    return this.availableOnline;
  }

  public setAvailableOnline(availableOnline) {
    this.availableOnline = availableOnline;
  }

  public setFlatRateRoutes(flatRateRoutes): void {
    this.flatRateRoutes = flatRateRoutes;
  }

  public getBlPrice(): number {
    return this.blPrice;
  }
  public setBlPrice(value: number) {
    this.blPrice = value;
  }

  public getBlMargin(): number {
    return this.blPriceMargin;
  }
  public setBlMargin(value: number) {
    this.blPriceMargin = value;
  }

  public isValid(): boolean {
    return !!this.name && !!this.carrier && !!this.validity;
  }
}
